import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { interval, map, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { Permissions } from '../constants/permissions';

export interface User {
  // password: string;
  username: string;
  roles: { role: string }[];
  permissions: { name: string }[];
}

export enum UserRoles {
  USER = 'user',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
}
@Injectable({
  providedIn: 'root',
})
export class Auth {
  private currentUser = this.getStoredUser();
  private baseUrl: string = `${environment.apiUrl}/auth`;
  private http: HttpClient = inject(HttpClient);
  private jwtHelper: JwtHelperService = inject(JwtHelperService);
  private tokenCheck$ = interval(30000); // check every 30s

  constructor() {
    // Auto check token expiration
    this.tokenCheck$.subscribe(() => {
      const token = localStorage.getItem(environment.JWT_STORAGE_KEY);
      if (token) {
        this.currentUser = this.decodeToken(token);
      }
      // console.log(token);
      // Auto logout function
      // if (token && this.isTokenExpired(token)) {
      //   this.logout();
      // }
    });

    const token = localStorage.getItem(environment.JWT_STORAGE_KEY);
    if (token) {
      this.currentUser = this.decodeToken(token);
    }
  }

  private getStoredUser(): User | null {
    const token = localStorage.getItem(environment.JWT_STORAGE_KEY);
    return token ? this.decodeToken(token) : null;
  }

  login(username: string, password: string): Observable<boolean> {
    return this.http
      .post<{ token: string }>(`${this.baseUrl}/login`, { username, password })
      .pipe(
        tap({
          next: ({ token }) => {
            // Side effects on success
            localStorage.setItem(environment.JWT_STORAGE_KEY, token);
            this.currentUser = this.decodeToken(token);
          },
          // error: (err) => {
          //   // Handle errors
          //   console.error('Login failed', err);
          // },
          // complete: () => {
          //   // Optional: runs when observable completes
          //   console.log('Login request completed');
          // },
        }),
        map(() => true),
      );
    // const foundUser = this.mockUsers.find(
    //   (u) => u.username === username && u.password === password
    // );

    // return of(!!foundUser).pipe(
    //   delay(500),
    //   map((success) => {
    //     if (success && foundUser) {
    //       const { password: _, ...userWithoutPassword } = foundUser;
    //       const fakeToken = this.generateFakeJWT({
    //         id: 1,
    //         username: userWithoutPassword.username,
    //         role: userWithoutPassword.role,
    //       });

    //       localStorage.setItem(environment.JWT_STORAGE_KEY, fakeToken);
    //       this.currentUser$.next(this.decodeToken(fakeToken));
    //     }
    //     return success;
    //   })
    // );
  }

  logout(): void {
    this.currentUser = null;
    localStorage.removeItem(environment.JWT_STORAGE_KEY);
  }

  isAuthenticated(): boolean {
    return this.currentUser !== null;
  }

  getCurrentUser(): User | null {
    const token = localStorage.getItem(environment.JWT_STORAGE_KEY);
    if (token) {
      this.currentUser = this.decodeToken(token);
    }
    return this.currentUser;
  }

  hasRole(checkRole: UserRoles): boolean {
    if (!this.currentUser) {
      return false;
    }

    return this.currentUser.roles.some((r) => r.role === checkRole);
  }

  hasPermission(checkPermission: Permissions): boolean {
    if (!this.currentUser) {
      return false;
    }

    return this.currentUser.permissions.some((r) => r.name === checkPermission);
  }

  private decodeToken(token: string): User | null {
    try {
      const payload = this.jwtHelper.decodeToken(token);
      return {
        username: payload.username,
        roles: payload.roles,
        permissions: payload.permissions,
      };
    } catch {
      return null;
    }
  }

  // TODO: Countdown in UI?
  getTokenExpiration(): number | null {
    const token = localStorage.getItem(environment.JWT_STORAGE_KEY);
    if (!token) return null;
    try {
      const payload = this.jwtHelper.decodeToken(token);
      return payload.exp * 1000; // ms
    } catch {
      return null;
    }
  }
}
